import _ from 'lodash';

import client from './RestClient';
import { SelectOptions } from 'components/commonType';
import { AxiosInstance } from 'axios';
import { KeywordSource, KeywordTag, SuggestKeywords } from 'core/product/Product';

export type RecommendKeywordsResponse = {
  recommendPool: SuggestKeywords[];
  enrichedSelected: SuggestKeywords[];
};

export interface AdRequestSourceWebService {
  getOS (): Promise<SelectOptions[]>;
  getSpaceTypes (): Promise<SelectOptions[]>;
  getDevice (): Promise<SelectOptions[]>;
  getRecommendKeywords (input: { goodsCodes: string[], selectedKeywords: string[] }): Promise<RecommendKeywordsResponse>;
}

export class RestfulAdRequestSourceWebService
  implements AdRequestSourceWebService {
  restClient: AxiosInstance;

  constructor (restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  pickRecords (response: any) {
    return _.sortBy(_.get(response, 'records', []), ['label']).map(record => ({
      ...record,
      options: record.options ? _.sortBy(record.options, ['label']) : record.options
    }));
  }
  async getOS (): Promise<SelectOptions[]> {
    const response = await this.restClient.get(
      '/v2/ad-request-source/os'
    );
    return this.pickRecords(response.data);
  }
  async getSpaceTypes (): Promise<SelectOptions[]> {
    const response = await this.restClient.get(
      '/v2/ad-request-source/space-types'
    );
    return this.pickRecords(response.data);
  }

  async getDevice (): Promise<SelectOptions[]> {
    const response = await this.restClient.get(
      `/v2/ad-request-source/device-types`
    );
    return this.pickRecords(response.data);
  }

  async getRecommendKeywords (input: { goodsCodes: string[], selectedKeywords: string[] }): Promise<RecommendKeywordsResponse> {
    const response = await this.restClient.post(
      '/pchome/recommendKeywords',
      input
    );
    const mapRow = (record: any): SuggestKeywords => ({
      suggestKeyword: _.get(record, 'suggestKeyword'),
      bidPrice: _.get(record, 'bidPrice', 0),
      maxCpc: _.get(record, 'maxCpc', 0),
      cpcCounts: _.get(record, 'cpcCounts', 0),
      keywordSearchVolume: _.get(record, 'keywordSearchVolume', 0),
      last7DayGrowthRate: _.get(record, 'last7DayGrowthRate', 0),
      last30DayGrowthRate: _.get(record, 'last30DayGrowthRate', 0),
      keywordAdCompetition: _.get(record, 'keywordAdCompetition', 0),
      keywordVersion: _.get(record, 'keywordVersion', ''),
      keywordTag: _.get(record, 'keywordTag') as KeywordTag | undefined,
      sources: _.get(record, 'sources', []) as KeywordSource[]
    });
    return {
      recommendPool: _.defaultTo(response.data.recommendPool, []).map(mapRow),
      enrichedSelected: _.defaultTo(response.data.enrichedSelected, []).map(mapRow)
    };
  }
}
